<template>
    <ul>
        <li v-for="(collection, index) in collections" :key="`collection-${index}`">
            <a class="fullmenu__link" @click="$router.push(`/collection/${collection.code}`)">
                <strong>{{ collection.name }}</strong>
                <!-- {{ collection.summary }} -->
            </a>
        </li>
    </ul>
</template>
<script>
export default {
    props: {
        collections: { type: Array, default: [] },
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.$nextTick(function() {
                setTimeout(function() {
                    var HEADER = document.querySelector(".header");
                    let link = document.querySelectorAll(".fullmenu__link");

                    for (let i = 0; i < link.length; i++) {
                        link[i].addEventListener("click", function() {
                            HEADER.classList.remove("active");
                            console.log("aa");
                        });
                    }
                }, 500);
            });
        },
    },
};
</script>
